import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import './PricingCard.css';

export default function PricingCard({
  title,
  subtitle,
  items,
  positiveColor = '#28a745',
  negativeColor = '#dc3545',
}) {
  return (
    <div className="pricing-card">
      <header className="pricing-header">
        <h2 className="pricing-title">{title}</h2>
        {subtitle && <p className="pricing-subtitle">{subtitle}</p>}
      </header>

      <ul className="pricing-list">
        {items.map(({ text, included }, i) => (
          <li key={i} className="pricing-item">
            {included ? (
              <FaCheckCircle
                className="icon"
                style={{ color: positiveColor }}
              />
            ) : (
              <FaTimesCircle
                className="icon"
                style={{ color: negativeColor }}
              />
            )}
            <span className="item-text">{text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
